<template>
	<div class="floating-code-container" id="floatingContainer"></div>

	<Header></Header>
	<div class="mainlayout_aside_and_main">
		<!-- <Aside></Aside> -->
		<div class="mainlayout_router_view">
			<div class="mainlayout_router_view_bg"></div>
			<!-- <div class="customer_service_show_btn" @click="show_customer_service" v-show="false"> -->
			<div class="customer_service_show_btn" @click="show_customer_service" v-show="true">


			</div>
			<div class="customer_service_layout" v-show="false">
				<div class="customer_service_title">
					<div class="customer_service_title_icon">

					</div>
					<div class="customer_service_title_text">
						为之易智能客服
					</div>
					<div class="close_customer_service" @click="close_customer_service">
						X
					</div>
				</div>
				<div class="customer_service_answer">
					<div class="customer_service_answer_item" v-for="obj in messages" :id="'item_' + obj['id']">
						<div v-if="obj['type'] == 1">
							<div class="customer_service_answer_item_time">
								{{ obj['time'] }}
							</div>
							<div class="customer_service_answer_item_img">

							</div>
							<div class="customer_service_answer_item_value" :id="'value_' + obj['id']">
								{{ obj['data_'] }}

							</div>
						</div>
						<div v-else-if="obj['type'] == 2">
							<div class="customer_service_answer_item_time">
								{{ obj['time'] }}
							</div>
							<div class="customer_service_answer_item_img_input">

							</div>
							<div class="customer_service_answer_item_value_input" :id="'value_' + obj['id']">
								{{ obj['data_'] }}
							</div>
						</div>
					</div>
				</div>
				<div class="input_user_info">
					<div class="input_user_title">
						您可以留个联系方式，技术人员会对接您~
					</div>
					<el-input v-model="user_name" :rows="1" type="text" placeholder="您的称呼" resize="none"
						class="input_user_name_layout" />
					<el-input v-model="user_phone" :rows="1" type="text" placeholder="您的手机" resize="none"
						class="input_user_phone_layout" />

					<div class="submit_user_info_layout" @click="submit_user_info">
						提交
					</div>
				</div>
				<div class="customer_service_edit">
					<div class="customer_service_edit_value">
						<el-input v-model="user_input" :rows="3" type="textarea" placeholder="很高兴为您服务,请输入您想要咨询的问题。"
							resize="none" style="font-size: 16px;" />
					</div>
					<div class="customer_service_edit_submit" @click="startStreamChat">
						发送
					</div>

				</div>
				<!-- <p v-for="(message, index) in messages" :key="index">{{ message }}</p> -->
			</div>
			<router-view />
		</div>
		<!-- <Footer></Footer> -->
	</div>

</template>

<script>
import Header from '@/components/Header'
// import Aside from  '@/components/Aside'
import Footer from '@/components/Footer'
import request from "@/utils/request";
import axios from 'axios';


export default {
	name: "Layout",
	components: {
		Header,
		// Aside,
		Footer
	},
	data() {
		return {
			base_url: SERVER_URL,
			messages: [], // 存储接收到的消息
			str_messages: "",
			user_input: "",
			user_phone: "",
			user_name: "",
			config: {
				isRunning: true,
				density: 'high',
				speed: 'fast',
				theme: 0,
				spawnInterval: 2000
			},
			densitySettings: {
				low: { interval: 3500, maxCodes: 8 },
				normal: { interval: 2000, maxCodes: 12 },
				high: { interval: 1200, maxCodes: 18 }
			},
			speedSettings: {
				slow: 12,
				normal: 8,
				fast: 5
			},
			themes: [
				['rgba(0, 255, 65, 0.7)', 'rgba(100, 150, 255, 0.6)', 'rgba(255, 100, 150, 0.6)', 'rgba(150, 255, 100, 0.6)'],
				['rgba(255, 100, 100, 0.7)', 'rgba(100, 255, 255, 0.6)', 'rgba(255, 255, 100, 0.6)', 'rgba(255, 150, 100, 0.6)'],
				['rgba(150, 100, 255, 0.7)', 'rgba(255, 200, 100, 0.6)', 'rgba(100, 255, 200, 0.6)', 'rgba(200, 100, 255, 0.6)']
			],
			characters: [
				'0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'
			],
			container: "",
			spawnTimer: "",
			activeElements: 0,

		};
	},
	mounted() {

		this.messages.push({
			"time": this.get_now_time(),
			"data_": "欢迎您来咨询！为之易主要产品有各行业视觉检测设备、精密检测设备、老化监控设备以及各类型软件，可以免费测样和上门测试。",
			"id": 1,
			"type": 1
		}
			// ,{
			// 	"time":this.get_now_time(),
			// 	"data":"ttttt",
			// 	"id":2,
			// 	"type":2
			// }
		);
		// document.getElementById("value_1").innerHTML = this.messages[0]['data']


		// // AOI客服,暂时不开放
		let that = this
		// 绑定事件监听器到整个文档
		// document.addEventListener('keydown', function (event) {
		// 	// 检查按下的键是否是回车键（键码13）
		// 	if (event.keyCode === 13) {
		// 		event.preventDefault();
		// 		that.startStreamChat();
		// 	}
		// 	if (event.key === 'Escape' || event.key === 'Esc') {
		// 		that.close_customer_service();
		// 	}

		// });
		this.close_customer_service()
		// this.show_customer_service()

		// 初始化
		this.startFloating();

		// 窗口大小改变时清理越界元素
		window.addEventListener('resize', () => {
			const elements = this.container.querySelectorAll('.floating-code');
			elements.forEach(el => {
				if (parseInt(el.style.left) > window.innerWidth) {
					el.style.left = (window.innerWidth - 200) + 'px';
				}
			});
		});
	},
	unmounted() {
		if (this.spawnTimer) {
			clearTimeout(this.spawnTimer);
		}
	},
	methods: {
		createFloatingCode() {
			if (!this.config.isRunning || this.activeElements >= this.densitySettings[this.config.density].maxCodes) {
				return;
			}

			const element = document.createElement('div');
			element.className = `floating-code variant-${Math.floor(Math.random() * 4)}`;
			element.textContent = this.characters[Math.floor(Math.random() * this.characters.length)];

			// 随机位置
			const startX = Math.random() * (window.innerWidth - 200);
			const driftX = (Math.random() - 0.5) * 300; // 水平漂移
			const rotation = (Math.random() - 0.5) * 30; // 轻微旋转

			element.style.left = startX + 'px';
			element.style.setProperty('--drift-x', driftX + 'px');
			element.style.setProperty('--rotate', rotation + 'deg');
			element.style.animationDuration = this.speedSettings[this.config.speed] + 's';
			element.style.animationDelay = Math.random() * 2 + 's';

			// 应用主题颜色
			const themeColors = this.themes[this.config.theme];
			const colorIndex = Math.floor(Math.random() * themeColors.length);
			element.style.color = themeColors[colorIndex];

			this.container.appendChild(element);
			this.activeElements++;

			// 动画完成后移除元素
			setTimeout(() => {
				if (element.parentNode) {
					element.parentNode.removeChild(element);
					this.activeElements--;
				}
			}, (this.speedSettings[this.config.speed] + 2) * 1000);
		},
		startFloating() {
			this.container = document.getElementById('floatingContainer');
			if (!this.config.isRunning) return;

			this.createFloatingCode();
			this.spawnTimer = setTimeout(this.startFloating, this.densitySettings[this.config.density].interval + Math.random() * 1000);
		},
		toggleFloating() {
			this.config.isRunning = !this.config.isRunning;
			const status = document.getElementById('status');

			if (this.config.isRunning) {
				this.startFloating();
				status.textContent = `运行中 - ${this.config.density === 'low' ? '稀疏' : this.config.density === 'normal' ? '普通' : '密集'}密度`;
			} else {
				clearTimeout(this.spawnTimer);
				status.textContent = '已暂停';
			}
		},
		adjustDensity() {
			const densities = ['low', 'normal', 'high'];
			const currentIndex = densities.indexOf(this.config.density);
			this.config.density = densities[(currentIndex + 1) % densities.length];

			const status = document.getElementById('status');
			const densityText = this.config.density === 'low' ? '稀疏' : this.config.density === 'normal' ? '普通' : '密集';
			status.textContent = `运行中 - ${densityText}密度`;

			// 重启定时器
			if (this.config.isRunning) {
				clearTimeout(this.spawnTimer);
				this.startFloating();
			}
		},
		changeSpeed() {
			const speeds = ['slow', 'normal', 'fast'];
			const currentIndex = speeds.indexOf(this.config.speed);
			this.config.speed = speeds[(currentIndex + 1) % speeds.length];

			// 更新现有元素的动画速度
			const existingElements = this.container.querySelectorAll('.floating-code');
			existingElements.forEach(el => {
				el.style.animationDuration = this.speedSettings[this.config.speed] + 's';
			});
		},
		changeTheme() {
			this.config.theme = (this.config.theme + 1) % this.themes.length;

		},


		submit_user_info() {

			if (this.user_name && this.user_phone && this.user_phone.length == 11) {
				let url = "https://doeasyit.com/web"
				request.post(url + '/submit_user_info', {
					"user_name": this.user_name,
					"phone": this.user_phone + " | 咨询"
				}).then(res => {
					console.log(res)
					if (res.status != "200") {
						this.$message({
							type: "error",
							message: res.error_info
						})
					} else {
						this.$message({
							type: "success",
							message: res.data
						})

					}
				}).catch(function () {
					ElMessage.error('服务器异常 ！！！')
				})

				let id = this.messages.length + 1
				this.messages.push({
					"time": this.get_now_time(),
					"data_": "信息提交成功，稍后会有技术人员联系您~",
					"id": id,
					"type": 1
				})
				setTimeout(function () {
					document.getElementsByClassName("customer_service_answer")[0].scrollTop = document.getElementsByClassName("customer_service_answer")[0].scrollHeight
				}, 50)

				this.user_name = ""
				this.user_phone = ""
			} else {
				this.$message({
					type: "error",
					message: "请输入正确的信息"
				})
			}

		},
		show_customer_service() {
			document.getElementsByClassName("customer_service_show_btn")[0].style.display = "none"
			document.getElementsByClassName("customer_service_layout")[0].style.display = "inline-block"
		},
		close_customer_service() {
			document.getElementsByClassName("customer_service_layout")[0].style.display = "none"
			document.getElementsByClassName("customer_service_show_btn")[0].style.display = "inline-block"

		},
		get_now_time() {
			var now = new Date();
			var month = now.getMonth() + 1; // 获取月份 (0-11，所以需要加1)
			var date = now.getDate(); // 获取日期 (1-31)
			var hours = now.getHours(); // 获取小时 (0-23)
			var minutes = now.getMinutes(); // 获取分钟 (0-59)
			var seconds = now.getSeconds(); // 获取秒 (0-59)

			// 将月份、日期、小时、分钟和秒格式化为两位数字
			month = month < 10 ? '0' + month : month;
			date = date < 10 ? '0' + date : date;
			hours = hours < 10 ? '0' + hours : hours;
			minutes = minutes < 10 ? '0' + minutes : minutes;
			seconds = seconds < 10 ? '0' + seconds : seconds;

			var timeString = month + '-' + date + ' ' + hours + ':' + minutes + ':' + seconds;
			return timeString

		},
		add_message(id) {
			this.messages.push({
				"time": this.get_now_time(),
				"data": this.user_input,
				"id": id,
				"type": 2
			});
			this.user_input = ""
			let that = this
			setTimeout(function () {
				let obj = document.getElementById("value_" + id)
				// console.log(obj)
				if (obj) {
					that.messages[id - 1]['data'] = that.messages[id - 1]['data'].replaceAll("\n", '<br>')
					obj.innerHTML = that.messages[id - 1]['data']
				} else {
					that.messages[id - 1]['data_'] = that.messages[id - 1]['data']
				}
				document.getElementsByClassName("customer_service_answer")[0].scrollTop = document.getElementsByClassName("customer_service_answer")[0].scrollHeight

			}, 50)

		},
		async startStreamChat() {
			if (this.user_input == "") {
				return -1
			}
			const jsonData = {
				"message": this.user_input,
				"mode": "chat"
			}

			let id = this.messages.length + 1
			this.add_message(id)

			// this.base_url = "http://192.168.1.10:9917/api"
			// this.base_url = "http://aigcwzy.tpddns.cn:9917/api"

			const url = this.base_url + '/stream_chat';

			try {
				const response = await fetch(url, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Authorization: 'Bearer 44WSHAA-7TB4YPK-MVRZTTK-4JQVGWT',
					},
					body: JSON.stringify(jsonData),
				});

				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}

				let response_id = id + 1
				this.messages.push({
					"time": this.get_now_time(),
					"data_": "请稍等...",
					"id": response_id,
					"type": 1
				});

				let begin_sgin = false
				let str_messages = ""

				const reader = response.body.getReader();
				const decoder = new TextDecoder('utf-8');

				let count_br = 0

				// 添加超时检测
				let lastDataTime = Date.now();
				const timeoutCheck = setInterval(() => {
					const timeSinceLastData = Date.now() - lastDataTime;
					if (timeSinceLastData > 20000) { // 20秒超时
						clearInterval(timeoutCheck);
						this.messages[response_id - 1]['data'] = str_messages + "⚠️ 服务器响应超时，请重试";
						document.getElementById("value_" + response_id).innerHTML = this.messages[response_id - 1]['data'];
						reader.cancel(); // 取消数据读取
					}
				}, 1000);

				while (true) {
					const { done, value } = await reader.read();

					if (done) {
						clearInterval(timeoutCheck); // 清除超时检测
						console.log("done")
						// this.messages[response_id-1]['data'] = "服务器繁忙，请重新尝试~~~"
						// document.getElementById("value_"+response_id).innerHTML = this.messages[response_id-1]['data']
						// document.getElementsByClassName("customer_service_answer")[0].scrollTop = document.getElementsByClassName("customer_service_answer")[0].scrollHeight
						break
					}

					const chunk = decoder.decode(value, { stream: true });
					lastDataTime = Date.now(); // 更新最后接收数据的时间
					const lines = chunk.split('\n');

					for (const line of lines) {
						if (line.startsWith('data:')) {
							const jsonStr = line.replace('data:', '').trim();
							// console.log(jsonStr)
							if (jsonStr.slice(-1) != '}') {
								continue
							}
							const data = JSON.parse(jsonStr);
							// console.log(data.textResponse)
							if (data.textResponse == "</think>") {
								begin_sgin = true
								continue
							}
							if (data.textResponse && begin_sgin) {
								// console.log(JSON.stringify(data.textResponse))
								let temp_str = data.textResponse
								// console.log(temp_str)
								if (count_br < 2) {
									temp_str = temp_str.replaceAll("\n", '')
									count_br++
								} else {
									temp_str = temp_str.replaceAll("\n", '<br>')
								}
								str_messages = str_messages + temp_str
								this.messages[response_id - 1]['data'] = str_messages
								document.getElementById("value_" + response_id).innerHTML = this.messages[response_id - 1]['data']
								document.getElementsByClassName("customer_service_answer")[0].scrollTop = document.getElementsByClassName("customer_service_answer")[0].scrollHeight
							}
						}
					}
				}
			} catch (error) {
				console.error('Error:', error);
				// console.log("*-/*-/*-/-*/*-")
				// document.getElementById("value_"+response_id).innerHTML = this.messages[response_id-1]['data']
				// console.log("value_"+(id+1))
				document.getElementById("value_" + (id + 1)).innerHTML = "服务器繁忙，请重新尝试~~~"

			}
		},


	},
}
</script>

<style>
/* 漂浮代码容器 */
.floating-code-container {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	pointer-events: none;
	z-index: 1;
}

/* 单个代码片段样式 */
.floating-code {
	position: absolute;
	color: rgba(0, 255, 65, 0.7);
	font-size: 14px;
	font-weight: 300;
	letter-spacing: 1px;
	opacity: 0;
	white-space: nowrap;
	text-shadow: 0 0 10px rgba(0, 255, 65, 0.3);
	animation: floatCode 8s linear infinite;
}

.floating-code.variant-1 {
	color: rgba(100, 150, 255, 0.6);
	text-shadow: 0 0 8px rgba(100, 150, 255, 0.3);
}

.floating-code.variant-2 {
	color: rgba(255, 100, 150, 0.6);
	text-shadow: 0 0 8px rgba(255, 100, 150, 0.3);
}

.floating-code.variant-3 {
	color: rgba(150, 255, 100, 0.6);
	text-shadow: 0 0 8px rgba(150, 255, 100, 0.3);
}

/* @keyframes floatCode {
	0% {
		opacity: 0;
		transform: translateY(100vh) translateX(0) rotate(0deg) scale(0.8);
	}

	5% {
		opacity: 1;
	}

	95% {
		opacity: 1;
	}

	100% {
		opacity: 0;
		transform: translateY(-100px) translateX(var(--drift-x, 0px)) rotate(var(--rotate, 0deg)) scale(1.1);
	}
} */
@keyframes floatCode {
	0% {
		opacity: 0;
		top: -100px;
		/* 从屏幕上方开始 */
		transform: translateX(0) rotate(0deg);
	}

	10% {
		opacity: 1;
	}

	90% {
		opacity: 1;
	}

	100% {
		opacity: 0;
		top: 100%;
		/* 移动到屏幕下方 */
		transform: translateX(100px) rotate(10deg);
	}
}

/* 页面内容样式 */
.content {
	position: relative;
	z-index: 10;
	max-width: 1200px;
	margin: 0 auto;
	padding: 50px 20px;
	background: rgba(0, 0, 0, 0.3);
	backdrop-filter: blur(5px);
	border-radius: 10px;
	margin-top: 100px;
	border: 1px solid rgba(0, 255, 65, 0.2);
}

.content h1 {
	color: #00ff41;
	text-align: center;
	font-size: 3em;
	margin-bottom: 30px;
	text-shadow: 0 0 20px rgba(0, 255, 65, 0.5);
	animation: glow 3s ease-in-out infinite alternate;
}

@keyframes glow {
	from {
		text-shadow: 0 0 20px rgba(0, 255, 65, 0.5);
	}

	to {
		text-shadow: 0 0 30px rgba(0, 255, 65, 0.8), 0 0 40px rgba(0, 255, 65, 0.3);
	}
}

.content p {
	font-size: 1.2em;
	line-height: 1.8;
	margin-bottom: 20px;
	color: #cccccc;
}

.product-showcase {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
	gap: 30px;
	margin-top: 50px;
}

.product-card {
	background: rgba(0, 0, 0, 0.6);
	border: 1px solid #333;
	border-radius: 10px;
	padding: 25px;
	text-align: center;
	transition: all 0.3s ease;
	position: relative;
	overflow: hidden;
}

.product-card:hover {
	border-color: #00ff41;
	box-shadow: 0 0 25px rgba(0, 255, 65, 0.3);
	transform: translateY(-5px);
}

.product-icon {
	width: 80px;
	height: 80px;
	background: linear-gradient(135deg, #333 0%, #555 100%);
	border-radius: 8px;
	margin: 0 auto 15px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #00ff41;
	font-size: 24px;
	font-weight: bold;
}

.product-card h3 {
	color: #00ff41;
	margin-bottom: 10px;
	font-size: 1.3em;
}

.product-card p {
	color: #999;
	font-size: 0.9em;
	margin: 0;
}

/* 控制面板 */
.controls {
	position: fixed;
	top: 20px;
	right: 20px;
	z-index: 100;
	background: rgba(0, 0, 0, 0.8);
	border: 1px solid #00ff41;
	border-radius: 8px;
	padding: 15px;
	backdrop-filter: blur(10px);
}

.control-btn {
	display: block;
	width: 100%;
	margin: 5px 0;
	padding: 8px 15px;
	background: rgba(0, 255, 65, 0.2);
	border: 1px solid #00ff41;
	color: #00ff41;
	border-radius: 4px;
	cursor: pointer;
	font-family: 'Courier New', monospace;
	font-size: 12px;
	transition: all 0.3s ease;
}

.control-btn:hover {
	background: rgba(0, 255, 65, 0.4);
	box-shadow: 0 0 10px rgba(0, 255, 65, 0.5);
}

/* 状态显示 */
.status {
	color: #00ff41;
	font-size: 10px;
	text-align: center;
	margin-top: 10px;
	opacity: 0.7;
}

/* 响应式设计 */
@media (max-width: 768px) {
	.floating-code {
		font-size: 12px;
	}

	.content {
		margin-top: 50px;
		padding: 30px 15px;
	}

	.content h1 {
		font-size: 2em;
	}

	.controls {
		top: 10px;
		right: 10px;
		padding: 10px;
	}
}
</style>